import * as React from "react";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import ListItem from "@mui/material/ListItem";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

export default function ItemList(props) {
  return (
    <ListItem alignItems="flex-start">
      <ListItemAvatar>
        <Avatar alt="Post Image" src={props.details.img} />
      </ListItemAvatar>
      <ListItemText
        primary={props.details.title}
        secondary={
          <Typography variant="body2" component="div">
            {props.details.description}
          </Typography>
        }
      />
      <div>
        <Tooltip title="Edit">
          <IconButton onClick={() => console.log("Edit!")}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete">
          <IconButton onClick={() => console.log("Delete!")}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </div>
    </ListItem>
  );
}
